let inputs = document.querySelectorAll('.js-filter-input'),
    apply = document.querySelector('.js-apply-filters'),
    show = document.querySelectorAll('.js-show-filters'),
    showMobile = document.querySelectorAll('.js-show-filters--mobile'),
    filterElementsMobile = document.querySelectorAll('.filter-form__controls--mobile'),
    filters = document.querySelector('.js-filters'),
    filterBar = document.querySelector('.js-filter-bar'),
    filterGroups = document.querySelectorAll('.js-filter-group'),
    filterTabs = document.querySelectorAll('.js-filter-tab'),
    filterElements = [filters, filterBar];

inputs.forEach((input) => {
    input.addEventListener('change', () => {
        apply.classList.add('active');
    });
});

show.forEach((show) => {
  show.addEventListener('click', (event) => {
      show.classList.toggle('active');
      event.preventDefault();
      filters.classList.toggle('active');

  });
});


var config = {
    animation: {
        enable: false
    },
    selectors: {
        target: '.js-grid-item'
    },
    load: {
        sort: 'color'
    },
    multifilter: {
        enable: true // enable the multifilter extension for the mixer
    }
};

// Pass the configuration object to the mixitup factory function
const containerEl = document.querySelector('.js-grid');

// "No results" message, shown when a filter combination matches nothing.
// MixItUp v3 has no `templates.fail` config (sealed config throws), so we
// toggle our own element off the `mixEnd` event instead.
if (containerEl) {
    const failMessage = document.createElement('li');
    failMessage.className = 'grid__item grid__item--full-width js-filter-no-results';
    failMessage.setAttribute('aria-live', 'polite');
    failMessage.innerHTML = '<h4 class="headline">No products match your filters.</h4>';
    failMessage.hidden = true;
    containerEl.appendChild(failMessage);

    containerEl.addEventListener('mixEnd', (e) => {
        failMessage.hidden = e.detail.state.totalShow > 0;
    });

    var mixer = mixitup(containerEl, config);
}

// ---- URL-param deep linking --------------------------------------------
// Lets nav submenu items (and any shared link) open a pre-filtered collection,
// e.g. /collections/textiles?filter=prints  (comma-separates multiple values).
// Filter state is also written back to the URL so the view is shareable.
if (containerEl && typeof mixer !== 'undefined') {
    const cssEsc = (s) =>
        (window.CSS && CSS.escape) ? CSS.escape(s) : s.replace(/[^a-zA-Z0-9_-]/g, '\\$&');

    const controlFor = (value) =>
        document.querySelector(`[data-toggle=".${cssEsc(value)}"]`);

    // Apply any ?filter= present on load.
    const applyFromUrl = () => {
        const raw = new URLSearchParams(window.location.search).get('filter');
        if (!raw) return;
        const values = raw.split(',').map((s) => s.trim()).filter(Boolean);
        if (!values.length) return;

        const controls = [];
        const orphans = [];
        values.forEach((v) => {
            const btn = controlFor(v);
            if (btn) { controls.push(btn); } else { orphans.push('.' + cssEsc(v)); }
        });

        // Reveal the filter UI so the active selection is visible.
        if (filters) { filters.classList.add('active'); }
        show.forEach((s) => s.classList.add('active'));

        if (orphans.length) {
            // One or more values have no matching control button: filter directly.
            const selector = controls
                .map((b) => b.getAttribute('data-toggle'))
                .concat(orphans)
                .join(', ');
            mixer.filter(selector || 'all');
        } else {
            // All values map to controls — click them so MixItUp's multifilter
            // state and the active button styling stay in sync.
            controls.forEach((b) => b.click());
        }
    };

    // Reflect the active filter back into ?filter= for sharing. We read
    // MixItUp's own state (activeFilter.selector) rather than control classes,
    // so this is independent of the library's internal class names.
    containerEl.addEventListener('mixEnd', (e) => {
        const selector =
            (e.detail && e.detail.state && e.detail.state.activeFilter &&
                e.detail.state.activeFilter.selector) || '';
        const tokens = (selector.match(/\.[A-Za-z0-9_-]+/g) || [])
            .map((s) => s.slice(1))
            .filter((c) => c !== 'js-grid-item'); // ignore the base target class
        const url = new URL(window.location.href);
        if (tokens.length) { url.searchParams.set('filter', tokens.join(',')); }
        else { url.searchParams.delete('filter'); }
        window.history.replaceState(null, '', url);
    });

    applyFromUrl();

    // Keep the "Clear all" link honest — strip ?filter= as well.
    document.querySelectorAll('.active-filters__clear').forEach((clear) => {
        const url = new URL(clear.getAttribute('href'), window.location.origin);
        url.searchParams.delete('filter');
        clear.setAttribute('href', url.pathname + url.search);
    });
}

// Rollover (hover) image deferral now lives in assets/hover-defer.js, loaded
// globally from theme.liquid so it also runs on pages without this section.
